import { render, staticRenderFns } from "./Extensions3.vue?vue&type=template&id=86d1dcb8&scoped=true"
import script from "./Extensions3.vue?vue&type=script&lang=js"
export * from "./Extensions3.vue?vue&type=script&lang=js"
import style0 from "./Extensions3.vue?vue&type=style&index=0&id=86d1dcb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d1dcb8",
  null
  
)

export default component.exports